<template>
    <v-card rounded="lg" flat color="grey-f7" style="overflow: unset;">
        <div class="pa-20 pa-md-30 pa-lg-40">
            <v-row class="row--x-small">
                <v-col cols="12" lg="6">
                    <v-row class="row--x-small">
                        <v-col cols="12" lg="auto" class="mb-10 mb-md-0">
                            <p class="page-text font-weight-medium min-w-lg-100px mt-md-10 mt-lg-12">근로계약 생성일</p>
                        </v-col>
                        <v-col>
                            <v-row align="center" class="row--x-small">
                                <v-col cols="12" xl="auto">
                                    <v-row align="center" class="row--x-small">
                                        <v-col>
                                            <v-date-field v-model="query['searchDateValue'][0]" v-bind="{ ...attrs_input }" placeholder="기간검색(시작일)" class="mw-lg-170px" />
                                        </v-col>
                                        <v-col cols="auto">
                                            <p class="page-text page-text--sm">~</p>
                                        </v-col>
                                        <v-col cols="12" sm="auto">
                                            <v-date-field v-model="query['searchDateValue'][1]" v-bind="{ ...attrs_input }" placeholder="기간검색(종료일)" class="mw-lg-170px" />
                                        </v-col>
                                    </v-row>
                                </v-col>
                                <v-col cols="12" xl="auto">
                                    <v-btn text class="no-search-date-value-btn" @click="putNoSearchDateValue">
                                        <v-simple-checkbox :value="noSearchDateValue" hide-details class="v-input--checkbox--lg" color="primary" @click.stop.capture="putNoSearchDateValue" />
                                        <span> 전체기간 </span>
                                    </v-btn>
                                </v-col>
                            </v-row>
                        </v-col>
                    </v-row>
                </v-col>
                <v-col cols="12" lg="6">
                    <v-row class="row--x-small">
                        <v-col cols="12" lg="3">
                            <v-select v-bind="attrs_input" v-model="query['searchKey']" placeholder="전체" :items="searchKeys" clearable item-text="text" item-value="value" />
                        </v-col>
                        <v-col>
                            <v-text-field v-model="query['searchValue']" v-bind="attrs_input" placeholder="검색내용을 입력하세요." class="v-text-field--search" @keydown.enter="emit">
                                <template #prepend-inner>
                                    <div class="pa-8"><i class="icon icon-search-black" /></div>
                                </template>
                            </v-text-field>
                        </v-col>
                        <v-col cols="12" sm="auto">
                            <v-btn color="grey-6" block dark class="min-w-sm-80px min-w-lg-100px" @click="emit">검색</v-btn>
                        </v-col>
                    </v-row>
                </v-col>
            </v-row>
        </div>
    </v-card>
</template>

<script>
import { attrs_input } from "@/assets/variables";

import VDateField from "@/components/plugins/vuetify/v-date-field.vue";

let initQuery = (query = {}) => ({
    ...(query || {}),

    ["searchDateValue"]: [...(query["searchDateValue"] ?? [null, null])],

    ["searchKey"]: query?.["searchKey"] || null,
    ["searchValue"]: query?.["searchValue"] || null,
});

let searchKeys = [
    { value: "subject", text: "계약명" },
    { value: "form.name", text: "계약서 명칭" },
    { value: "person.username", text: "아이디" },
    { value: "application.resume.personalInformation.name", text: "근로자 이름" },
    { value: "application.resume.personalInformation.email", text: "근로자 이메일" },
    { value: "application.resume.personalInformation.phone", text: "근로자 전화번호" },
];

export default {
    components: {
        VDateField,
    },
    data: () => ({
        query: initQuery(),

        attrs_input,
        searchKeys,
    }),
    computed: {
        noSearchDateValue() {
            return !this.query["searchDateValue"].some((value) => value != null);
        },
    },
    mounted() {
        this.sync();
    },
    watch: {
        "$route.query"() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.query = initQuery(this.$route.query);
        },
        emit() {
            let { ...query } = this.query;

            delete query.page;

            if (!query["searchDateValue"][0] && !query["searchDateValue"][1]) delete query["searchDateValue"];

            if (!query?.["searchKey"]) delete query["searchKey"];
            if (!query?.["searchValue"]) delete query["searchValue"];

            this.$router.push({ query });
        },
        putNoSearchDateValue() {
            this.query["searchDateValue"] = [null, null];
        },
    },
};
</script>

<style lang="scss" scoped>
.row--x-small {
    margin: -4px;
}
.row--x-small > [class*="col"] {
    padding: 4px;
}
.no-search-date-value-btn {
    min-width: unset;
    height: unset;
    padding: 0;

    &::before {
        display: none;
    }
}
</style>
